import { VersionedAgentSchema } from "@redotech/redo-model/agents/versioned-agent";

export const updateVersionedAgent = {
  name: "updateVersionedAgent" as const,
  input: VersionedAgentSchema.pick({ _id: true, prompt: true }),
  output: VersionedAgentSchema,
};
